<button
    #tooltip="matTooltip"
    class="tool-tip"
    [ngClass]="{'tooltip--small':this.tooltipSize === TooltipSize.Small}"
    (click)="onTooltipClick(tooltip, $event)"
    (mouseenter)="$event.stopImmediatePropagation()"
    (mouseleave)="$event.stopImmediatePropagation()"
    [matTooltip]=tooltipText
    [attr.aria-label]="tooltipText">
    i
</button>